import { useQuery, gql } from '@apollo/client';

export const GET_ALL_QUESTIONNAIRES_SETTINGS = gql`
  query getAllPlatformQuestionnaireSetting {
    getAllPlatformQuestionnaireSetting {
      _id
      name
    }
  }
`;

export const useGetAllPlatformQuestionnaireSetting = () => {
  const { data, loading } = useQuery(GET_ALL_QUESTIONNAIRES_SETTINGS, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    questionnaireSetting: data?.getAllPlatformQuestionnaireSetting || [],
    loading,
  };
};
